import React from 'react';
import {
  FileParams,
  TemplateComponentsProps,
  theme,
  useRenderTemplateUi,
} from '@zonofi/common';
import Icon from 'react-native-easy-icon';
import {
  MessageTemplateProps,
  chatStyles,
  useGetMessageData,
} from '@zonofi/chats-common';
import { isNaN } from 'lodash';
import { MessageBody } from './message-body';

export const ReplyView: React.FC<MessageTemplateProps> = ({
  envelope,
  replyData,
  scrollToItem = () => {},
}) => {
  const { variant, userName, userNameColor, template, msgId } =
    useGetMessageData(envelope);

  const renderedComponents = useRenderTemplateUi({
    messageId: msgId,
    template,
    templateUI: TemplateComponents,
  });

  let replyName = replyData?.name;
  if (!isNaN(Number(replyName))) {
    const firstTwo = replyName.slice(0, 2);
    const remaining = replyName.slice(2);
    replyName = `+${firstTwo} ${remaining}`;
  }

  return (
    <div
      className="reply-view"
      style={{ borderLeftColor: '#632BB5' }}
      onClick={() => {
        return scrollToItem(envelope?.message?._id);
      }}
    >
      {replyData?.body ? (
        <>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <div
              className="comms-font-size-small"
              style={{ ...chatStyles.fontSemiBold12, color: userNameColor }}
            >{`~${replyName}`}</div>
            {/* <div className="comms-font-size-mini reply-number" style={{color: '#B0B0B0'}}>{replyNumber}</div> */}
          </div>
          <div
            className={`comms-font-size-regular`}
            style={chatStyles.fontRegular12}
          >
            {replyData?.body}
          </div>
        </>
      ) : (
        <>
          <div
            className="comms-font-size-small"
            style={{ ...chatStyles.fontSemiBold12, color: userNameColor }}
          >
            {variant === 'sender' ? 'You' : userName}
          </div>
          {renderedComponents}
        </>
      )}
    </div>
  );
};

const TemplateComponents: TemplateComponentsProps = {
  header: (_: string, text: string) => (
    <div
      className={`comms-font-size-regular`}
      style={chatStyles.fontSemiBold14Primary}
    >
      {text}
    </div>
  ),
  image: (_: string, text: string, file: FileParams[] = []) => (
    <div className={`comms-font-size-regular`}>
      {text.length > 0 && <div style={theme.fontConfig.semiBold}>{text}</div>}
      <div className="message-container" style={theme.fontConfig.regular}>
        <Icon type={'material'} name={'image'} color={theme.text.secondary} />
        {file?.length > 1 ? `${file.length} Images` : 'Image'}
      </div>
    </div>
  ),
  video: (_: string, text: string, file: FileParams[] = []) => (
    <div className={`comms-font-size-regular`}>
      {text.length > 0 && <div style={theme.fontConfig.semiBold}>{text}</div>}
      <div className="message-container" style={theme.fontConfig.regular}>
        <Icon type={'entypo'} name={'video'} color={theme.text.secondary} />
        {file?.length > 1 ? `${file.length} Videos` : 'Video'}
      </div>
    </div>
  ),
  body: (_: string, text: string) => <MessageBody text={text} />,
  footer: (_: string, text: string) => <MessageBody text={text} />,
  document: (_: string, text: string, file: FileParams[] = []) => (
    <div className={`comms-font-size-regular`}>
      {text.length > 0 && <div style={theme.fontConfig.semiBold}>{text}</div>}
      <div className="message-container" style={theme.fontConfig.regular}>
        <Icon
          type={'material-community'}
          name={'file'}
          color={theme.text.secondary}
        />
        {file?.length > 1 ? `${file.length} Documents` : 'Document'}
      </div>
    </div>
  ),
  audio: (_: string, text: string, file: FileParams[] = []) => (
    <div className={`comms-font-size-regular`}>
      {text.length > 0 && <div style={theme.fontConfig.semiBold}>{text}</div>}
      <div className="message-container" style={theme.fontConfig.regular}>
        <Icon
          type={'material-community'}
          name={'audio'}
          color={theme.text.secondary}
        />
        {file?.length > 1 ? `${file.length} Audio Files` : 'Audio File'}
      </div>
    </div>
  ),
  banner: (_x: string, _y: string) => null,
  button: (_x: string, _y: string) => null,
  location: (_: string, text: string) => <MessageBody text={text} />,
  contact: (_: string, text: string) => <MessageBody text={text} />,
};
